import { fg } from '@atlaskit/platform-feature-flags';

import type {
	RemoveNodeCommand,
	StreamingCommandFactory,
} from '../aiStreamingOrchestratorPluginType';

import { findNodeByLocalId } from './utils/find-node-by-local-id';

export const createRemoveNodeCommand: StreamingCommandFactory<RemoveNodeCommand> =
	(api) => (command) => {
		return api.core.actions.execute(({ tr }) => {
			return findNodeByLocalId(api, tr, command.localId, ({ node, pos }) => {
				if (fg('platform_editor_ai_instrumentation_updates')) {
					api.aiExperience.actions.tagAsAIStreamingTransformation(tr, { isFinal: true });
				}
				tr.delete(pos, pos + node.nodeSize).scrollIntoView();
			});
		});
	};
